"use strict";
var GenerateObservable_1 = require('./GenerateObservable');
exports.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/generate.js
// module id = 1065
// module chunks = 10